export function getRussianPhoneDigits(value, options = {}) {
  const { emptyAsPrefix = false } = options
  const digits = String(value || '').replace(/\D/g, '')

  if (!digits) return emptyAsPrefix ? '7' : ''

  let normalized = digits
  if (normalized.startsWith('8')) {
    normalized = `7${normalized.slice(1)}`
  } else if (!normalized.startsWith('7')) {
    normalized = `7${normalized}`
  }

  return normalized.slice(0, 11)
}

export function formatRussianPhoneDigits(digits) {
  if (!digits) return ''

  const normalized = getRussianPhoneDigits(digits)
  if (!normalized) return ''

  const a = normalized.slice(1, 4)
  const b = normalized.slice(4, 7)
  const c = normalized.slice(7, 9)
  const d = normalized.slice(9, 11)

  let out = '+7'
  if (a) out += ` (${a}`
  if (a.length === 3) out += ')'
  if (b) out += ` ${b}`
  if (c) out += `-${c}`
  if (d) out += `-${d}`

  return out
}

export function formatRussianPhone(value, options = {}) {
  const digits = getRussianPhoneDigits(value, options)
  return formatRussianPhoneDigits(digits)
}

export function normalizeRussianPhone(value, options = {}) {
  const digits = getRussianPhoneDigits(value, options)
  return digits ? `+${digits}` : ''
}
